import { FC, useEffect, useState } from "react";
import { message, Table, Button, Popconfirm } from "antd";
import Card from "antd/es/card/Card";
import { useNavigate } from "react-router-dom";
import { useGetUserReservations, useDeleteReservation } from "../../shared/services/planning/planning.service";
import type { TableProps } from 'antd';
import { ResponsePlanning } from "../../shared/types/response/responseplanning.model";
import { DeleteReservationRequest } from "../../shared/types/request/deletereservation.model";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Grid } from "antd";

dayjs.extend(customParseFormat);


const ListeReservations : FC = () => {

    const navigate = useNavigate();

    //Active le scoll sur la table seulement pour téléphone
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();

    const[messageApi, contextHolder] = message.useMessage();
    const[idReservation, setIdReservation] = useState<number>();
    const[deleteRequest, setDeleteRequest] = useState<DeleteReservationRequest>();
    const[dataTable, setDataTable] = useState<ResponsePlanning[]>([]);

    const {data, error} = useGetUserReservations();

    const {dataDel, errorDel} = useDeleteReservation(deleteRequest);

    function confirm() {
        if(idReservation && localStorage.getItem("username")){
            const requestDelete : DeleteReservationRequest = {
                id: idReservation || 0,
                username: localStorage.getItem("username") || ""
            }
            setDeleteRequest(requestDelete);
        }
    };

    useEffect(() =>{
        if(errorDel && errorDel.response.data.erreur){
            messageApi.error(errorDel.response.data.erreur);
        }else{
            if(errorDel)
            {
                messageApi.error(errorDel.message);
            }
        }
    }, [errorDel])

    useEffect(() => {
        if(dataDel && dataDel.ok){
            messageApi.success(dataDel.ok);
            setDataTable(prev => prev.filter(item => item.id !== idReservation));
        }
    }, [dataDel])

    useEffect(() => {
        if(data){
            setDataTable(data);
        }
    }, [data])

    const columns: TableProps<ResponsePlanning>['columns'] = [
        {
            title: 'Date de début',
            key: 'debut',
            sorter: (a, b) => {
                const dateA = dayjs(`${a.dateDebut} ${a.heureDebut}`, "DD/MM/YYYY HH:mm:ss").toDate();
                const dateB = dayjs(`${b.dateDebut} ${b.heureDebut}`, "DD/MM/YYYY HH:mm:ss").toDate();
                return dateA.getTime() - dateB.getTime();
            },
            defaultSortOrder: 'descend',
            render: (_, r) => `${r.dateDebut} ${r.heureDebut}`,
        },
        {
            title: 'Date de fin',
            key: 'fin',
            render: (_, r) => `${r.dateFin} ${r.heureFin}`,
        },
        {
            title: 'Numéro de poste',
            key: 'numPost',
            render: (_, r) => `${r.numPoste}`,
        },
        {
            title: 'Annulation de la réservation',
            key: 'action',
            render: (_, r) => (
                <Popconfirm
                    title="Annuler la réservation"
                    description="Etes-vous sûr d'annuler la réservation ?"
                    onConfirm={() => confirm()}
                    okText="Oui"
                    cancelText="Non"
                >
                    <Button type="primary" onClick={() => setIdReservation(r.id)}>Annulation</Button>
                </Popconfirm>
            )
        }
    ];

    useEffect(() =>{
        if(error){
            navigate("/connexion");
        }
    }, [error])

    function retourEspaceUser(){
        navigate("/espaceuser");
    }

    return(
        <Card title={<span style={{ textAlign: "center" }}>Liste de vos réservations</span>} variant="borderless" className="responsive-card">
            {contextHolder}
            <Table<ResponsePlanning> columns={columns} dataSource={dataTable} rowKey="id" scroll={!screens.md ? { x: "max-content" } : undefined}  />
            <Button onClick={retourEspaceUser} style={{ marginTop: "24px" }}>Retour</Button>
        </Card>
    )
}

export default ListeReservations;